import { components, GroupBase, MultiValueRemoveProps } from 'react-select';

import { CloseIcon } from '../../../icons';
import * as Colors from '../../../constants/Colors';

export const MultiValueRemove = <
    Option,
    IsMulti extends boolean = false,
    Group extends GroupBase<Option> = GroupBase<Option>
>(
    props: MultiValueRemoveProps<Option, IsMulti, Group>
) => {
    return (
        <components.MultiValueRemove {...props}>
            <CloseIcon width="20px" height="20px" color={Colors.black} cursor="pointer" />
        </components.MultiValueRemove>
    );
};
